import { _decorator, Enum } from 'cc';
import { DEV } from 'cc/env';
import BaseAction from './BaseAction';
import Processor from '../../Components/Misc/Processor';

const { ccclass, property } = _decorator;

export enum ProcessorActionType {
    Play,
    Pause,
    Resume,
    Stop,
    ForceStop,
}

@ccclass('ProcessorAction')
export default class ProcessorAction extends BaseAction {
    @property(Processor)
    public readonly processor: Processor = null;
    @property({ type: Enum(ProcessorActionType), displayName: DEV && '操作類型', tooltip: DEV && '要進行什麼行為' })
    public readonly type: ProcessorActionType = ProcessorActionType.Play;
}
